<template>
  <div class="mt-1">
    <b-row>
      <b-col offset="3" cols="9">
        <small class="text-danger" v-if="sourceLayerIsEmpty">
            Należy wybrać warstwę źródłową.
        </small>
        <small class="text-danger" v-if="noSelectionAvailaible">
            Nie zaznaczono żadnych elementów.
        </small>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="3">
        <label for="sourceLayerSelect">Warstwa źródłowa</label>
      </b-col>
      <b-col cols="9">
        <b-form-select id="sourceLayerSelect" v-model="selectedSourceLayer" :options="sourceLayers" :state="sourceLayerIsEmpty || noSelectionAvailaible ? false : null">
          <template slot="first">
            <option :value="null">Wybierz</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    sourceLayers: { type: Array, default: () => [{ text: 'Warstwa aktywna', value: { type: 'activeLayer' } }, { text: 'Zaznaczenie', value: { type: 'selection' } }] },
    validated: Boolean
  },
  computed: {
    selectedSourceLayer: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); }
    },
    sourceLayerIsEmpty() {
      return this.validated && !this.value;
    },
    noSelectionAvailaible() {
      return this.validated && this.value === 'selection' && [...this.$store.getters.selectedMapFeatures].length === 0;
    }
  }
}
</script>

<style>

</style>
